/**
 * Clash banner (partials/clash-banner): the server prints times in UTC, here they switch to the visitor's time zone
 * and date, the way the Clash tab in the client shows them
 */
import { locale } from '../i18n';

export function initClashBanner() {
    const times = document.querySelectorAll('.clash-banner time[data-clash-format]');
    if (!times.length) {
        return;
    }

    const formats = {
        day: new Intl.DateTimeFormat(locale, { weekday: 'short', day: 'numeric', month: 'short' }),
        time: new Intl.DateTimeFormat(locale, { hour: 'numeric', minute: '2-digit' }),
    };
    times.forEach((time) => {
        time.textContent = formats[time.dataset.clashFormat].format(new Date(time.dateTime));
    });
}
